(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiet-lash-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.qlp-shell').forEach((shell) => {
    shell.querySelectorAll('[data-gallery-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.galleryButton;
        shell.querySelectorAll('[data-gallery-button]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        shell.querySelectorAll('[data-gallery-panel]').forEach((panel) => {
          const active = panel.dataset.galleryPanel === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });

    shell.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.closest('.qlp-quantity')?.querySelector('input[name="quantity"]');
        if (!input) return;
        const change = Number(button.dataset.quantityChange);
        const current = Number(input.value) || 1;
        input.value = Math.max(1, current + change);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    shell.querySelectorAll('input[name="id"]').forEach((input) => {
      input.addEventListener('change', () => {
        const price = shell.querySelector('[data-product-price]');
        const addButton = shell.querySelector('[data-add-button]');
        const mobilePrice = shell.querySelector('[data-mobile-buy] strong');
        const available = input.dataset.available === 'true';
        if (price) price.textContent = input.dataset.price;
        if (mobilePrice) mobilePrice.textContent = input.dataset.price;
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? shell.dataset.addLabel : shell.dataset.unavailableLabel;
        }
      });
    });

    shell.querySelector('[data-scroll-to-buy]')?.addEventListener('click', () => {
      shell.querySelector('#qlp-buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => shell.querySelector('input[name="id"]')?.focus(), 450);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
